package com.bikompanion.data.cache

import kotlinx.serialization.Serializable
import com.bikompanion.domain.ParkingType

@Serializable
internal data class CachedParkingSpot(
    val id: String,
    val latitude: Double,
    val longitude: Double,
    val capacity: Int? = null,
    val isCovered: Boolean? = null,
    val address: String? = null,
    // The enum's name, not the type itself: the domain module carries no serialization
    // dependency, so its types never appear directly in a @Serializable shape.
    val type: String = ParkingType.Other.name,
)
